export default () => ({
  handler: 'externalUrl',
  data: ({ externalUrl, openInNewTab }) => ({ url: externalUrl, openInNewTab }),
});
